export const MESSAGING_ERROR_CODES = {
  AUTH_REQUIRED: 'AUTH_REQUIRED',
  INVALID_CONVERSATION_PARTICIPANTS: 'INVALID_CONVERSATION_PARTICIPANTS',
  SHOP_REQUIRED: 'SHOP_REQUIRED',
  TARGET_REQUIRED: 'TARGET_REQUIRED',
  UNRELATED_SHOP_PARTICIPANT: 'UNRELATED_SHOP_PARTICIPANT',
  APPOINTMENT_CONTEXT_FORBIDDEN: 'APPOINTMENT_CONTEXT_FORBIDDEN',
  MESSAGE_PARTICIPANT_BLOCKED: 'MESSAGE_PARTICIPANT_BLOCKED',
  BLOCK_TARGET_REQUIRED: 'BLOCK_TARGET_REQUIRED',
  MESSAGE_CONTENT_REQUIRED: 'MESSAGE_CONTENT_REQUIRED',
  MESSAGE_TOO_LONG: 'MESSAGE_TOO_LONG',
  CONVERSATION_NOT_FOUND: 'CONVERSATION_NOT_FOUND',
  NOT_A_PARTICIPANT: 'NOT_A_PARTICIPANT',
  CONVERSATION_CLOSED: 'CONVERSATION_CLOSED',
  CONVERSATION_ID_REQUIRED: 'CONVERSATION_ID_REQUIRED',
  MESSAGE_REPORT_DETAILS_REQUIRED: 'MESSAGE_REPORT_DETAILS_REQUIRED',
  MESSAGE_REPORT_FORBIDDEN: 'MESSAGE_REPORT_FORBIDDEN',
  CONVERSATION_ACCESS_FORBIDDEN: 'CONVERSATION_ACCESS_FORBIDDEN',
  RATE_LIMITED: 'RATE_LIMITED',
} as const;

export type MessagingErrorCode = (typeof MESSAGING_ERROR_CODES)[keyof typeof MESSAGING_ERROR_CODES];
